import ServiceApi from "../ServiceApi";
class UserServiceApi extends ServiceApi {
  constructor() {
    super("userService", "user");
  }
  userRegister(subscription = 0, terms_accepted = 0) {
    const params = {};
    if (subscription) {
      params.subscription = 1;
    }
    if (terms_accepted) {
      params.terms_accepted = 1;
    }
    return this.request("register", params);
  }

  /**
   * Special registration method for vkplay sites
   * https://jira.my.games/browse/GODWEB-68807
   * @param {number} subscription
   * @param {number} terms_accepted
   * @returns {ServiceMethodResponse}
   */
  userRegisterV2(subscription = 0, terms_accepted = 0) {
    const params = {};
    if (subscription) {
      params.subscription = 1;
    }
    if (terms_accepted) {
      params.terms_accepted = 1;
    }
    return this.request("register_v2", params);
  }
  /**
   *
   * @param {array} [needly_fields]
   */
  getUserData(needly_fields) {
    const fields = needly_fields || [
      "profile_renamed",
      "early_access",
      "last_promotion_promo_code_type",
      "preorder",
      "beta_testing",
      "last_hwid",
      "registration_url",
    ];
    return this.request("getProfileInfo", { fields });
  }
  /**
   *
   * @param {string} phone
   * @param {string} vkpay_wallet
   */
  sendPhoneAndVkpay(phone, vkpay_wallet) {
    let params = { phone: phone, vkpayWallet: vkpay_wallet };
    return this.request("requestConfirmationCode", params);
  }
  /**
   *
   * @param {string} phone
   * @param {number} code
   */
  sendSmsConfirm(phone, code) {
    let params = { phone: phone, code: code };
    return this.request("confirm", params);
  }
  getEmailVerificationStatus() {
    return this.request("getVerificationStatus");
  }
  /**
   *
   * @param {number} profile_id
   */
  setReferrer(profile_id) {
    let params = { referrerProfileId: profile_id };
    return this.request("setReferrer", params);
  }
  pwGetGameAccounts() {
    return this.request("pwGetGameAccounts", {});
  }
  setTermsAccepted() {
    return this.request("setTermsAccepted", {});
  }

  /**
   * @param {string} nickname
   */
  setNickname(nickname) {
    let params = { nickname };
    return this.request("setNickname", params);
  }
}
const service = new UserServiceApi();
export default service;
